export const tagsValidation = (schema, maxCountTags) => {
    return schema.test(
        'isMaxCountTags',
        `Tags field must have less than or equal to ${maxCountTags} items`,
        (value) => (value?.length > 0 && value?.split(",").length - 1) <= maxCountTags - 1
    )
}